import { render, staticRenderFns } from "./BadgeGroup.vue?vue&type=template&id=648841aa&scoped=true&"
import script from "./BadgeGroup.vue?vue&type=script&lang=js&"
export * from "./BadgeGroup.vue?vue&type=script&lang=js&"
import style0 from "./BadgeGroup.vue?vue&type=style&index=0&id=648841aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648841aa",
  null
  
)

export default component.exports